import type { SVGProps } from "react";
export interface BracketRoundEllipsisHrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BracketRoundEllipsisHrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BracketRoundEllipsisHrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12c0-4.102 2.037-7.728 5.15-9.92l.099-.061a1.126 1.126 0 0 1 1.198 1.9l-.466.35A9.86 9.86 0 0 0 3.125 12c0 3.13 1.456 5.92 3.731 7.731l.466.349.09.072a1.125 1.125 0 0 1-1.288 1.83l-.099-.062-.57-.428A12.1 12.1 0 0 1 .876 12Zm20 0a9.86 9.86 0 0 0-4.197-8.08l.649-.92.647-.92a12.11 12.11 0 0 1 5.15 9.92c0 4.102-2.037 7.727-5.15 9.92a1.125 1.125 0 0 1-1.296-1.84A9.86 9.86 0 0 0 20.875 12m-4.468-9.648a1.125 1.125 0 0 1 1.567-.272l-1.296 1.84a1.125 1.125 0 0 1-.271-1.567Z"
      />
      <path
        fill={color}
        d="M16 11.629a.62.62 0 0 0-.124.37l.011.127a.6.6 0 0 0 .113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126A.6.6 0 0 0 17 11.63v.741Zm-4.388-.496a.6.6 0 0 0-.111-.245v.741a.6.6 0 0 0 .11-.244l.014-.127-.013-.126Zm-1.112-.245a.62.62 0 0 0-.124.37l.011.127a.6.6 0 0 0 .113.244zm-3.388.245A.6.6 0 0 0 8 11.629v.741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126ZM7 11.629a.62.62 0 0 0-.125.37l.012.127A.6.6 0 0 0 7 12.37zm2.125.37a1.625 1.625 0 0 1-3.242.167L5.876 12l.009-.165a1.625 1.625 0 0 1 1.615-1.46l.167.009a1.623 1.623 0 0 1 1.458 1.615m4.5 0a1.625 1.625 0 0 1-3.242.167L10.376 12l.009-.165A1.625 1.625 0 0 1 12 10.376l.167.009c.82.083 1.46.774 1.46 1.615Zm4.5 0a1.625 1.625 0 0 1-3.242.167L14.876 12l.009-.165a1.625 1.625 0 0 1 1.616-1.459l.166.009c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
